export const shippingTranslations = {
    de: {
        pieceCount: 'Einzelstücke',
        proposal: 'Rechnerischer Vorschlag',
        finalized: 'Festgeschriebene oder versendete Belege können nicht geändert werden.',
        title: 'Gebinde und Gewichtsangaben',
        pdfTitle: 'Gebinde und Gewicht',
        description: 'Optionale Übersicht für neue Belege. Bestehende Belege behalten ihre gespeicherten Einstellungen.',
        packagingEnabled: 'Gebindeübersicht ausgeben',
        weightEnabled: 'Gewicht ausgeben',
        weightMode: 'Gewichtsauswahl',
        NET: 'Nettogewicht',
        GROSS: 'Bruttogewicht',
        BOTH: 'Netto und brutto',
        netKg: 'Gesamtgewicht netto',
        grossKg: 'Gesamtgewicht brutto',
        documentTypes: 'Belegarten',
        catalogue: 'Zentrale Gebindearten',
        add: 'Gebindeart anlegen',
        code: 'Stabiler Code',
        name: 'Bezeichnung',
        order: 'Reihenfolge',
        active: 'Aktiv',
        empty: 'Noch keine Gebindearten zugeordnet.',
        saveError: 'Speichern fehlgeschlagen. Bitte Eingaben prüfen.',
        saved: 'Angaben gespeichert',
        loadError: 'Angaben konnten nicht geladen werden.',
        packagingType: 'Zentrale Gebindeart',
        unassigned: 'Nicht zugeordnet',
        summaryDefault: 'Variante für diese Gebindeübersicht',
        weightDefault: 'Dieses Gebinde als Bruttogewichtsgrundlage',
        weightHint: 'Artikelgewichte gelten je Basiseinheit in kg. Gebindebrutto umfasst Ware und enthaltene Verpackung je ganzem Gebinde und ersetzt das Artikelbrutto. Zusätzliche Transportverpackung ist nicht enthalten; dafür eine tatsächliche Gesamtwiegung erfassen.',
        netUnit: 'Nettogewicht je Basiseinheit (kg)',
        grossUnit: 'Bruttogewicht je Basiseinheit (kg)',
        calculated: 'rechnerisch',
        estimated: 'voraussichtlich / rechnerisch',
        actual: 'tatsächlich bestätigt',
        levelsHint: 'Die Gebindearten beschreiben dieselbe Ware auf verschiedenen Ebenen. Rechnerische Paletten sind keine bestätigten Mischpaletten.',
        needsReview: 'Versandangaben erneut prüfen: Warenmengen oder Grundlagen wurden geändert. Bis zur Bestätigung werden nur vollständige Rechenwerte ausgegeben.',
        missingHint: 'Unvollständige Summen erscheinen nicht im PDF. Betroffene Artikel:',
        missingBasis: 'Historische Gewichts- und Gebindegrundlagen fehlen',
        missingFactor: 'Gebindezuordnung oder Faktor fehlt',
        ambiguousVariant: 'Übersichtsvariante eindeutig auswählen',
        missingNet: 'Nettogewicht fehlt',
        missingGross: 'Bruttogewicht fehlt',
        negativeQuantity: 'Negative Warenmenge prüfen',
        confirm: 'Versandmengen / Gesamtwiegung bestätigen',
        auto: 'Zur automatischen Berechnung',
        reason: 'Begründung / Wiegenachweis',
        actualHint: 'Nur tatsächlich erfasste Werte eingeben. Leere Felder verwenden den berechneten Vorschlag. Eine Bruttowiegung umfasst die gesamte Ware einschließlich aller Verpackung.',
        saveFirst: 'Änderungen am Beleg zuerst speichern.',
        confirmation: 'Bestätigung: {{user}} · {{date}}',
        up: 'Nach oben',
        down: 'Nach unten',
        invalidType: 'Unbekannte oder deaktivierte Gebindeart.',
        immutableCode: 'Der Code ist bereits vergeben oder unveränderlich. Neue Gebindearten benötigen einen eigenen Code.',
        oneVariant: 'Je Gebindeart nur eine Übersichtsvariante auswählen.',
        oneWeightBasis: 'Nur eine Bruttogewichtsgrundlage auswählen.',
        actualOnlyShipment: 'Tatsächliche Angaben sind nur bei Lieferschein oder Rechnung möglich.',
        featureDisabled: 'Das Modul ist deaktiviert.',
        conflict: 'Der Beleg wurde geändert. Bitte neu laden.',
        checkFields: 'Bitte alle markierten Felder prüfen.',
        edit: 'Bearbeiten',
        pdfSelection: 'PDF-Auswahl und Reihenfolge',
        massHint: 'Bei Gewichtseinheiten wird die Basismenge direkt in kg umgerechnet; das Stückgewicht wird nicht nochmals multipliziert.',
    },
    en: {
        pieceCount: 'Individual pieces',
        proposal: 'Calculated proposal',
        finalized: 'Finalized or sent documents cannot be changed.',
        title: 'Packaging and weights',
        pdfTitle: 'Packaging and weight',
        description: 'Optional summary for new documents. Existing documents retain their saved settings.',
        packagingEnabled: 'Show packaging summary',
        weightEnabled: 'Show weight',
        weightMode: 'Weight selection',
        NET: 'Net weight',
        GROSS: 'Gross weight',
        BOTH: 'Net and gross',
        netKg: 'Total net weight',
        grossKg: 'Total gross weight',
        documentTypes: 'Document types',
        catalogue: 'Central packaging types',
        add: 'Add packaging type',
        code: 'Stable code',
        name: 'Label',
        order: 'Order',
        active: 'Active',
        empty: 'No packaging types assigned yet.',
        saveError: 'Could not save. Please check your input.',
        saved: 'Details saved',
        loadError: 'Could not load details.',
        packagingType: 'Central packaging type',
        unassigned: 'Unassigned',
        summaryDefault: 'Variant for this packaging summary',
        weightDefault: 'Use this pack as the gross weight basis',
        weightHint: 'Article weights are kg per base unit. Pack gross weight includes goods and its packaging per whole pack and replaces article gross weight. Extra transport packaging is excluded; record an actual total weighing for it.',
        netUnit: 'Net weight per base unit (kg)',
        grossUnit: 'Gross weight per base unit (kg)',
        calculated: 'calculated',
        estimated: 'estimated / calculated',
        actual: 'actual, confirmed',
        levelsHint: 'Packaging types describe the same goods at different levels. Calculated pallets are not confirmed mixed pallets.',
        needsReview: 'Review shipping details: quantities or bases changed. Only complete calculated values are printed until confirmed again.',
        missingHint: 'Incomplete totals are omitted from the PDF. Affected articles:',
        missingBasis: 'Historical weight and packaging bases missing',
        missingFactor: 'Packaging assignment or factor missing',
        ambiguousVariant: 'Select one summary variant',
        missingNet: 'Net weight missing',
        missingGross: 'Gross weight missing',
        negativeQuantity: 'Review negative goods quantity',
        confirm: 'Confirm shipping quantities / total weighing',
        auto: 'Return to automatic calculation',
        reason: 'Reason / weighing reference',
        actualHint: 'Enter measured values only. Blank fields use the calculated proposal. Gross weighing covers all goods including all packaging.',
        saveFirst: 'Save document changes first.',
        confirmation: 'Confirmed: {{user}} · {{date}}',
        up: 'Move up',
        down: 'Move down',
        invalidType: 'Unknown or inactive packaging type.',
        immutableCode: 'The code is already used or immutable. New packaging types need a distinct code.',
        oneVariant: 'Select only one summary variant per packaging type.',
        oneWeightBasis: 'Select only one gross weight basis.',
        actualOnlyShipment: 'Actual values are available only for delivery notes or invoices.',
        featureDisabled: 'The module is disabled.',
        conflict: 'The document changed. Please reload.',
        checkFields: 'Please check all marked fields.',
        edit: 'Edit',
        pdfSelection: 'PDF selection and order',
        massHint: 'For mass units the base quantity converts directly to kg; per-piece weight is not multiplied again.',
    },
    tr: {
        pieceCount: 'Tekil adet',
        proposal: 'Hesaplanan öneri',
        finalized: 'Kesinleştirilmiş veya gönderilmiş belgeler değiştirilemez.',
        title: 'Ambalaj ve ağırlık bilgileri',
        pdfTitle: 'Ambalaj ve ağırlık',
        description: 'Yeni belgeler için isteğe bağlı özet. Mevcut belgelerin kayıtlı ayarları korunur.',
        packagingEnabled: 'Ambalaj özetini göster',
        weightEnabled: 'Ağırlığı göster',
        weightMode: 'Ağırlık seçimi',
        NET: 'Net ağırlık',
        GROSS: 'Brüt ağırlık',
        BOTH: 'Net ve brüt',
        netKg: 'Toplam net ağırlık',
        grossKg: 'Toplam brüt ağırlık',
        documentTypes: 'Belge türleri',
        catalogue: 'Merkezi ambalaj türleri',
        add: 'Ambalaj türü ekle',
        code: 'Sabit kod',
        name: 'Ad',
        order: 'Sıra',
        active: 'Etkin',
        empty: 'Henüz ambalaj türü atanmamış.',
        saveError: 'Kaydedilemedi. Lütfen girişleri kontrol edin.',
        saved: 'Bilgiler kaydedildi',
        loadError: 'Bilgiler yüklenemedi.',
        packagingType: 'Merkezi ambalaj türü',
        unassigned: 'Atanmamış',
        summaryDefault: 'Bu ambalaj özeti için varyant',
        weightDefault: 'Bu ambalajı brüt ağırlık temeli olarak kullan',
        weightHint: 'Ürün ağırlıkları temel birim başına kg değeridir. Ambalaj brütü bir tam ambalajdaki mal ve ambalajı içerir, ürün brütünün yerini alır. Ek nakliye ambalajı dahil değildir; bunun için gerçek toplam tartımı girin.',
        netUnit: 'Temel birim başına net ağırlık (kg)',
        grossUnit: 'Temel birim başına brüt ağırlık (kg)',
        calculated: 'hesaplanan',
        estimated: 'tahmini / hesaplanan',
        actual: 'gerçek, onaylanmış',
        levelsHint: 'Ambalaj türleri aynı malı farklı seviyelerde tanımlar. Hesaplanan paletler onaylanmış karma palet değildir.',
        needsReview: 'Sevkiyat bilgilerini tekrar kontrol edin: miktarlar veya temeller değişti. Onaylanana kadar yalnızca tam hesaplanan değerler yazdırılır.',
        missingHint: 'Eksik toplamlar PDF’de gösterilmez. İlgili ürünler:',
        missingBasis: 'Geçmiş ağırlık ve ambalaj temelleri eksik',
        missingFactor: 'Ambalaj ataması veya katsayısı eksik',
        ambiguousVariant: 'Tek bir özet varyantı seçin',
        missingNet: 'Net ağırlık eksik',
        missingGross: 'Brüt ağırlık eksik',
        negativeQuantity: 'Negatif mal miktarını kontrol edin',
        confirm: 'Sevkiyat miktarlarını / toplam tartımı onayla',
        auto: 'Otomatik hesaplamaya dön',
        reason: 'Gerekçe / tartım kaydı',
        actualHint: 'Yalnızca ölçülen değerleri girin. Boş alanlar hesaplanan öneriyi kullanır. Brüt tartım tüm malları ve ambalajları kapsar.',
        saveFirst: 'Önce belge değişikliklerini kaydedin.',
        confirmation: 'Onay: {{user}} · {{date}}',
        up: 'Yukarı taşı',
        down: 'Aşağı taşı',
        invalidType: 'Bilinmeyen veya devre dışı ambalaj türü.',
        immutableCode: 'Kod kullanımda veya değiştirilemez. Yeni ambalaj türleri için ayrı bir kod kullanın.',
        oneVariant: 'Her ambalaj türü için tek özet varyantı seçin.',
        oneWeightBasis: 'Tek bir brüt ağırlık temeli seçin.',
        actualOnlyShipment: 'Gerçek değerler yalnızca irsaliye veya faturada mümkündür.',
        featureDisabled: 'Modül devre dışı.',
        conflict: 'Belge değişti. Lütfen yeniden yükleyin.',
        checkFields: 'Lütfen işaretli alanları kontrol edin.',
        edit: 'Düzenle',
        pdfSelection: 'PDF seçimi ve sırası',
        massHint: 'Ağırlık birimlerinde temel miktar doğrudan kg’a çevrilir; parça ağırlığıyla tekrar çarpılmaz.',
    },
    fr: {
        pieceCount: 'Pièces individuelles',
        proposal: 'Proposition calculée',
        finalized: 'Les documents finalisés ou envoyés ne peuvent pas être modifiés.',
        title: 'Conditionnements et poids',
        pdfTitle: 'Conditionnements et poids',
        description: 'Récapitulatif facultatif pour les nouveaux documents. Les documents existants conservent leurs réglages.',
        packagingEnabled: 'Afficher le récapitulatif des conditionnements',
        weightEnabled: 'Afficher le poids',
        weightMode: 'Poids à afficher',
        NET: 'Poids net',
        GROSS: 'Poids brut',
        BOTH: 'Net et brut',
        netKg: 'Poids net total',
        grossKg: 'Poids brut total',
        documentTypes: 'Types de documents',
        catalogue: 'Types de conditionnement centraux',
        add: 'Créer un type de conditionnement',
        code: 'Code stable',
        name: 'Libellé',
        order: 'Ordre',
        active: 'Actif',
        empty: 'Aucun type de conditionnement attribué.',
        saveError: 'Échec de l’enregistrement. Vérifiez les saisies.',
        saved: 'Informations enregistrées',
        loadError: 'Impossible de charger les informations.',
        packagingType: 'Type de conditionnement central',
        unassigned: 'Non attribué',
        summaryDefault: 'Variante pour ce récapitulatif',
        weightDefault: 'Utiliser ce conditionnement comme base du poids brut',
        weightHint: 'Les poids article sont en kg par unité de base. Le brut du conditionnement inclut la marchandise et son emballage par conditionnement entier et remplace le brut article. Le suremballage de transport est exclu ; saisissez une pesée totale réelle.',
        netUnit: 'Poids net par unité de base (kg)',
        grossUnit: 'Poids brut par unité de base (kg)',
        calculated: 'calculé',
        estimated: 'prévisionnel / calculé',
        actual: 'réel, confirmé',
        levelsHint: 'Les types décrivent la même marchandise à différents niveaux. Les palettes calculées ne sont pas des palettes mixtes confirmées.',
        needsReview: 'Revérifiez les données d’expédition : quantités ou bases modifiées. Seuls les calculs complets sont imprimés jusqu’à nouvelle confirmation.',
        missingHint: 'Les totaux incomplets sont omis du PDF. Articles concernés :',
        missingBasis: 'Bases historiques de poids et conditionnement absentes',
        missingFactor: 'Attribution ou facteur manquant',
        ambiguousVariant: 'Sélectionnez une seule variante',
        missingNet: 'Poids net manquant',
        missingGross: 'Poids brut manquant',
        negativeQuantity: 'Vérifiez la quantité négative',
        confirm: 'Confirmer les quantités expédiées / la pesée totale',
        auto: 'Revenir au calcul automatique',
        reason: 'Motif / référence de pesée',
        actualHint: 'Saisissez uniquement les valeurs constatées. Les champs vides utilisent le calcul. La pesée brute inclut toute la marchandise et tous les emballages.',
        saveFirst: 'Enregistrez d’abord les modifications du document.',
        confirmation: 'Confirmation : {{user}} · {{date}}',
        up: 'Monter',
        down: 'Descendre',
        invalidType: 'Type inconnu ou désactivé.',
        immutableCode: 'Le code est déjà utilisé ou immuable. Un nouveau type nécessite un code distinct.',
        oneVariant: 'Choisissez une seule variante par type.',
        oneWeightBasis: 'Choisissez une seule base de poids brut.',
        actualOnlyShipment: 'Les valeurs réelles sont réservées aux bons de livraison et factures.',
        featureDisabled: 'Le module est désactivé.',
        conflict: 'Le document a changé. Rechargez-le.',
        checkFields: 'Vérifiez tous les champs signalés.',
        edit: 'Modifier',
        pdfSelection: 'Sélection et ordre dans le PDF',
        massHint: 'Pour les unités de masse, la quantité de base est convertie directement en kg, sans multiplication supplémentaire par un poids unitaire.',
    },
    es: {
        pieceCount: 'Piezas individuales',
        proposal: 'Propuesta calculada',
        finalized: 'No se pueden modificar documentos finalizados o enviados.',
        title: 'Embalajes y pesos',
        pdfTitle: 'Embalajes y peso',
        description: 'Resumen opcional para documentos nuevos. Los existentes conservan sus ajustes guardados.',
        packagingEnabled: 'Mostrar resumen de embalajes',
        weightEnabled: 'Mostrar peso',
        weightMode: 'Selección de peso',
        NET: 'Peso neto',
        GROSS: 'Peso bruto',
        BOTH: 'Neto y bruto',
        netKg: 'Peso neto total',
        grossKg: 'Peso bruto total',
        documentTypes: 'Tipos de documentos',
        catalogue: 'Tipos centrales de embalaje',
        add: 'Crear tipo de embalaje',
        code: 'Código estable',
        name: 'Nombre',
        order: 'Orden',
        active: 'Activo',
        empty: 'Todavía no hay tipos de embalaje asignados.',
        saveError: 'No se pudo guardar. Revise los datos.',
        saved: 'Datos guardados',
        loadError: 'No se pudieron cargar los datos.',
        packagingType: 'Tipo central de embalaje',
        unassigned: 'Sin asignar',
        summaryDefault: 'Variante para este resumen',
        weightDefault: 'Usar este embalaje como base del peso bruto',
        weightHint: 'Los pesos del artículo son kg por unidad base. El bruto del embalaje incluye mercancía y envase por embalaje completo y sustituye al bruto del artículo. Se excluye el embalaje adicional de transporte; registre un pesaje total real.',
        netUnit: 'Peso neto por unidad base (kg)',
        grossUnit: 'Peso bruto por unidad base (kg)',
        calculated: 'calculado',
        estimated: 'previsto / calculado',
        actual: 'real, confirmado',
        levelsHint: 'Los tipos describen la misma mercancía en distintos niveles. Los palés calculados no son palés mixtos confirmados.',
        needsReview: 'Revise los datos de envío: cambiaron cantidades o bases. Solo se imprimen cálculos completos hasta confirmar de nuevo.',
        missingHint: 'Los totales incompletos se omiten en el PDF. Artículos afectados:',
        missingBasis: 'Faltan bases históricas de peso y embalaje',
        missingFactor: 'Falta asignación o factor de embalaje',
        ambiguousVariant: 'Seleccione una única variante',
        missingNet: 'Falta peso neto',
        missingGross: 'Falta peso bruto',
        negativeQuantity: 'Revise la cantidad negativa',
        confirm: 'Confirmar cantidades enviadas / pesaje total',
        auto: 'Volver al cálculo automático',
        reason: 'Motivo / referencia de pesaje',
        actualHint: 'Introduzca solo valores constatados. Los campos vacíos usan el cálculo. El pesaje bruto incluye toda la mercancía y todos los embalajes.',
        saveFirst: 'Guarde primero los cambios del documento.',
        confirmation: 'Confirmación: {{user}} · {{date}}',
        up: 'Subir',
        down: 'Bajar',
        invalidType: 'Tipo desconocido o desactivado.',
        immutableCode: 'El código ya está en uso o es inmutable. Los tipos nuevos necesitan un código distinto.',
        oneVariant: 'Seleccione solo una variante por tipo.',
        oneWeightBasis: 'Seleccione solo una base de peso bruto.',
        actualOnlyShipment: 'Los valores reales solo se permiten en albaranes o facturas.',
        featureDisabled: 'El módulo está desactivado.',
        conflict: 'El documento cambió. Vuelva a cargarlo.',
        checkFields: 'Revise todos los campos marcados.',
        edit: 'Editar',
        pdfSelection: 'Selección y orden en PDF',
        massHint: 'Para unidades de masa, la cantidad base se convierte directamente a kg, sin multiplicar otra vez por un peso unitario.',
    },
};
//# sourceMappingURL=shipping-summary.js.map